<template>
    <div class="position-box reg">
      <div class="head">
          <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
          <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
          <div class="btn-reg" v-show="tabIdx == 0" @click="tab(1)">{{$t('lg.emregister')}}</div>
          <div class="btn-reg" v-show="tabIdx == 1" @click="tab(0)">{{$t('lg.phregister')}}</div>
        </div>
        <div class="cotainer">
            <h1 class="h1">{{$t('lg.kjzc2')}}</h1>
            <div class="tips" v-show="tabIdx == 1">{{$t('newReg.yx')}}</div>
            <div class="input-box" v-show="tabIdx == 1"><input class="input" v-model="account"  type="text" :placeholder="$t('lg.email')" onkeyup="this.value=this.value.replace(/[, ]/g,'')"></div>
            <div class="tips" v-show="tabIdx == 0">{{$t('newReg.sjh')}}</div>
            <div class="input-box" v-show="tabIdx == 0"><div class="code-box" @click="getCountyCode">
            {{country_code}} <img class="down" src="@/assets/down.png" alt=""></div><input class="input" v-model="account" type="text" :placeholder="$t('lg.pphone')" onkeyup="this.value=this.value.replace(/[, ]/g,'')"></div>
            <div class="tips">{{$t('xgdlmm.mm')}}</div>
            <div class="input-box input-pwd">
              <input class="input" v-model="password" type="password" ref="input1" :placeholder="$t('lg.ppwd')" autocomplete="off">
              <template v-if="isPwd1">
                <img v-if="!theme" v-show="password" src="@/assets/Log-In_close-eyes.png" style="width: .6rem" @click="shpass1" />
                <img v-else v-show="password" src="@/assets/theme/eyes.png" style="width: .6rem" @click="shpass1" />
             </template>
             <template v-else>
                <img v-if="!theme" v-show="password" src="@/assets/Log-In_eyes.png" style="width: .6rem" @click="shpass1" />
                <img v-else v-show="password" src="@/assets/theme/eyes2.png" style="width: .6rem" @click="shpass1" />
             </template>
            </div>
            <div class="tips">{{$t('xgdlmm.qrmm')}}</div>
            <div class="input-box input-pwd">
              <input class="input" v-model="password_again" type="password" ref="input2" :placeholder="$t('lg.ppwd2')" autocomplete="off">
              <template v-if="isPwd2">
                <img v-if="!theme" v-show="password_again" src="@/assets/Log-In_close-eyes.png" style="width: .6rem" @click="shpass2" />
                <img v-else v-show="password_again" src="@/assets/theme/eyes.png" style="width: .6rem" @click="shpass2" />
              </template>
              <template v-else>
                <img v-if="!theme" v-show="password_again" src="@/assets/Log-In_eyes.png" style="width: .6rem" @click="shpass2" />
                <img v-else v-show="password_again" src="@/assets/theme/eyes2.png" style="width: .6rem" @click="shpass2" />
              </template>
            </div>
            <div class="tips" v-show="invitecode">{{$t('newReg.yqm')}}</div>
            <div class="input-box input-pwd" v-show="invitecode"><input class="input" :disabled="disabled" v-model="invitation_code" type="text" :placeholder="$t('lg.qsryqm')"></div>
            <button class="btn-login btn-bg" :class="{active: isChecked}" @click="reg">{{$t('lg.register')}}</button>
        </div>
        <div class="tips-text">{{$t('lg.qtxyxzh')}}</div>
        <div class="agree-box" v-if="lang == 'ar'"><label  for="reg" class="text" style="padding: 0 .2rem 0 0">{{$t('lg.wyzx')}}</label><input class="checkbox" v-model="isChecked" id="reg" type="checkbox"></div>
        <div class="agree-box" v-else><input class="checkbox" v-model="isChecked" id="reg" type="checkbox"><label  for="reg" class="text">{{$t('lg.wyzx')}}</label></div>
    </div>
</template>

<script>
export default {
    name: 'quickReg',
    data () {
        return {
          theme: false,
          tabIdx: 0,
          isChecked: false ,
          checkcode: '',
          invitecode: '',
          country_code: '+213',
          country: '',
          account: '',
          code: '',
          password: '',
          password_again: '',
          invitation_code: '',
          disabled: false,
          countdown: 300,
          timer: null,
          regCheck: 0, //邮箱注册
          service_link: '',
          isPwd1: true,
          isPwd2: true,
          count: 1,
          lang: 'en'
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.country_code = localStorage.getItem('area_code') || '+213';
      this.country = localStorage.getItem('country') || '';
      this.regCheck = localStorage.getItem('regCheck') || 0;
      this.code = this.$route.query.code;
      this.checkcode = sessionStorage.getItem('checkcode') || '';
      this.invitecode = sessionStorage.getItem('invitecode') || '';
      this.lang = localStorage.getItem('language') || 'en';
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
      this.getCheckcode();
    },
    methods: {
      shpass1() {
        if(this.isPwd1){
          this.isPwd1 = false;
          this.$refs.input1.type = "text";
        }else{
          this.isPwd1 = true;
          this.$refs.input1.type = "password";
        }
      },
      shpass2() {
        if(this.isPwd2){
          this.isPwd2 = false;
          this.$refs.input2.type = "text";
        }else{
          this.isPwd2 = true;
          this.$refs.input2.type = "password";
        }
      },
       goBack(){
           this.$router.push('/login')
       },
       tab(idx){
        this.tabIdx = idx;
       },
       getCheckcode(){
           let params = {
               token: 1
           }
           this.$ajax.get('/web/reg_checkcode',{params}).then((res) => {
                let resData = res.data.data;
                this.checkcode = resData.checkcode;
                this.invitecode = resData.invitecode;
                sessionStorage.setItem("checkcode",resData.checkcode);
                sessionStorage.setItem("invitecode",resData.invitecode);
            }).catch(function(err){
                console.log(err)
            })
       },
       getCountyCode(){
           this.$router.push('/city')
       },
       reg(){//手机注册
         if(!this.isChecked) return;
            var reg = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+){6,12}$/;
            var regEmail = /^\S+[@]+\S/;
            var data = {
                index: 0,
                code: this.code,
                prefix: this.country_code,
                country: this.country,
                account: this.account,
                invitation_code: this.invitation_code,
                password: this.password,
                password_again: this.password_again,
                token: 1
            }
            if(this.tabIdx == 0){
                if(data.account == "" || data.account == null){
                    this.$toast.center(this.$t('lg.pphone'));
                    return false;
                }else if(!(/^[0-9]{4,11}$/.test(data.account))){
                  this.$toast.center(this.$t('tipsNew.telgsts'));
                  return false;
                }
            }else{
              if(data.account == "" || data.account == null){
                this.$toast.center(this.$t('lg.email'));
                return false;
              }else if(!regEmail.test(data.account)){
                  this.$toast.center(this.$t('tipsNew.emailgsts'));
                  return false;
              }
            }
            if(data.password == "" || data.password == null){
                this.$toast.center(this.$t('lg.ppwd'));
                return false;
            }else if(!reg.test(data.password)){
                this.$toast.center(this.$t('xgdlmm.mmts'));
                return false;
            }
            if(data.password != data.password_again){
              this.$toast.center(this.$t('tipsNew.lcmmbyz'));
              return false;
            }
            if(this.invitecode){
              if(data.invitation_code == "" || data.invitation_code == null){
                this.$toast.center(this.$t('lg.qsryqm'));
                return false;
              }
            }
            if(this.count == 1){
              this.count = 0;
            }else{
                return false;
            }
            this.$ajax.post('/web/userRegister',data).then((res) => {
                let resData = res.data;
                if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                  localStorage.setItem('token', resData.token_h5);
                  this.$toast.center(resData.message);
                  setTimeout(() => {
                      this.count = 1;
                      this.$router.push('/login')
                  }, 1000)
                }else{
                  this.count = 1;
                  this.$toast.center(resData.message);
                  return;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       //获取手机邮箱验证码
       getCode(){
         var type,index;
          if(this.tabIdx == 0){
            type = "bindemail",
            index = 1
          }else{
            type = "register",
            index = 0
          }
           let params = {
              index: index,
              account: this.account,
              type: type,
              prefix: this.country_code,
              token: 1
           }
           if(this.tabIdx == 0){
              if(this.account == '' || this.account == null){
                this.$toast.center(this.$t('lg.email'));
                return;
              }
           }else{
             if(this.account == '' || this.account == null){
                this.$toast.center(this.$t('lg.pphone'));
                return;
              }
           }
           if(this.count == 1){
            this.count = 0;
          }else{
              return false;
          }
          this.$ajax.get('/web/getCode',{params}).then((res) => {
              let resData = res.data;
              if(resData.code == 1){
                  this.$toast.center(resData.message);
                  this.count = 1;
                  return;
              }else{
                this.count = 1;
                this.settime()
              }
          }).catch(function(err){
              console.log(err)
          })
       },
       settime(){
           let generate_code = $("#fbtain");
           if (this.countdown == 0) {
                generate_code.attr("disabled", false);
                generate_code.val(this.$t('xgdlmm.hqyzm'));
                generate_code.css('color', '#5890bd');
                this.countdown = 300;
                return false;
            } else {
                generate_code.attr("disabled", true);
                generate_code.css('color', '#b6bfc4');
                generate_code.val(this.countdown + ' s');
                this.countdown--;
            }
            this.timer = setTimeout(() => {
                this.settime();
            }, 1000);
       },
       agree(){
           this.$router.push('/userAgreement')
       }
    },
    beforeDestroy(){
      clearTimeout(this.timer);
      this.timer = null;
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .btn-reg{
      position: absolute;
      right: .48rem;
      top: 50%;
      color: #588bf8;
      font-size: .48rem;
      transform: translateY(-50%);
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .42rem;
        right: .42rem;
        top: 1.6rem;
        bottom: 2.9rem;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .h1{
        padding: .18rem 0 .3rem;
        color: #000;
        font-size: .78rem;
    }
    .cotainer .h3{
        color: #9f9f9f;
        font-size: .4rem;
    }
    .cotainer .tab-box{
        display: flex;
        align-items: center;
        margin-top: .7rem;
    }
    .cotainer .tab-box .tab{
        width: 2.82rem;
        height: 0.85rem;
        color: #313131;
        font-size: .4rem;
        line-height: .85rem;
        text-align: center;
    }
    .cotainer .tab-box .tab.active{
        color: #588bf8;
        background-color: #f8f8f8;
        border-radius: 0.15rem;
    }
    .cotainer .tips{
        padding-top: .82rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .input-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .44rem 0 .38rem;
        border-bottom: .01rem solid #dadada;
    }
    .cotainer .code-box{
        display: flex;
        align-items: center;
    }
    .cotainer .code-box .down{
        width: .28rem;
        height: .22rem;
        margin: 0 .44rem 0 .24rem;
    }
    .cotainer .input-pwd{
        /* margin-top: .76rem; */
    }
    .cotainer .input-box .input{
        flex: 1;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .input-box .code{
        color: #588bf8;
        font-size: .42rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #c5cacd;
        font-size: .4rem;
    }
    .btn-login{
      display: block;
      width: 100%;
      margin-top: .6rem;
      background: #acacac;
    }
    .btn-login.active{
      background: #588bf8;
    }
    .tips-text{
      position: fixed;
      left: .42rem;
      right: .42rem;
      bottom: 1.2rem;
      color: #588bf8;
      font-size: .36rem;
    }
    .agree-box{
        position: fixed;
        left: .42rem;
        right: .42rem;
        bottom: 0;
        display: flex;
        align-items: center;
        padding: .42rem 0;
        color: #000;
        font-size: .38rem;
    }
    .agree-box .text{
      padding-left: .2rem;
      color: #000;
    }
</style>



// WEBPACK FOOTER //
// src/pages/quickReg.vue